'use strict';

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Clone = require('@hapi/hoek/lib/clone');
var Ignore = require('@hapi/hoek/lib/ignore');
var Reach = require('@hapi/hoek/lib/reach');
var Common = require('./common');
var Errors = require('./errors');
var State = require('./state');
var internals = {
  result: Symbol('result')
};
exports.entry = function (value, schema, prefs) {
  var settings = Common.defaults;
  if (prefs) {
    Assert(prefs.warnings === undefined, 'Cannot override warnings preference in synchronous validation');
    settings = Common.preferences(Common.defaults, prefs);
  }
  var result = internals.entry(value, schema, settings);
  Assert(!result.mainstay.externals.length, 'Schema with external rules must use validateAsync()');
  var outcome = {
    value: result.value
  };
  if (result.error) {
    outcome.error = result.error;
  }
  if (result.mainstay.warnings.length) {
    outcome.warning = Errors.details(result.mainstay.warnings);
  }
  if (result.mainstay.debug) {
    outcome.debug = result.mainstay.debug;
  }
  return outcome;
};
exports.entryAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value, schema, prefs) {
    var settings, result, mainstay, root, _iterator, _step, _step$value, method, path, label, node, key, parent, output, outcome;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          settings = Common.defaults;
          if (prefs) {
            settings = Common.preferences(Common.defaults, prefs);
          }
          result = internals.entry(value, schema, settings);
          mainstay = result.mainstay;
          if (!result.error) {
            _context.next = 7;
            break;
          }
          if (mainstay.debug) {
            result.error.debug = mainstay.debug;
          }
          throw result.error;
        case 7:
          if (!mainstay.externals.length) {
            _context.next = 42;
            break;
          }
          root = result.value;
          _iterator = _createForOfIteratorHelper(mainstay.externals);
          _context.prev = 10;
          _iterator.s();
        case 12:
          if ((_step = _iterator.n()).done) {
            _context.next = 33;
            break;
          }
          _step$value = _step.value, method = _step$value.method, path = _step$value.path, label = _step$value.label;
          node = root;
          key = void 0;
          parent = void 0;
          if (path.length) {
            key = path[path.length - 1];
            parent = Reach(root, path.slice(0, -1));
            node = parent[key];
          }
          _context.prev = 18;
          _context.next = 21;
          return method(node);
        case 21:
          output = _context.sent;
          if (!(output === undefined || output === node)) {
            _context.next = 24;
            break;
          }
          return _context.abrupt("continue", 31);
        case 24:
          if (parent) {
            parent[key] = output;
          } else {
            root = output;
          }
          _context.next = 31;
          break;
        case 27:
          _context.prev = 27;
          _context.t0 = _context["catch"](18);
          _context.t0.message += " (".concat(label, ")"); // Change message to include path
          throw _context.t0;
        case 31:
          _context.next = 12;
          break;
        case 33:
          _context.next = 38;
          break;
        case 35:
          _context.prev = 35;
          _context.t1 = _context["catch"](10);
          _iterator.e(_context.t1);
        case 38:
          _context.prev = 38;
          _iterator.f();
          return _context.finish(38);
        case 41:
          result.value = root;
        case 42:
          if (!(!settings.warnings && !settings.debug)) {
            _context.next = 44;
            break;
          }
          return _context.abrupt("return", result.value);
        case 44:
          outcome = {
            value: result.value
          };
          if (mainstay.warnings.length) {
            outcome.warning = Errors.details(mainstay.warnings);
          }
          if (mainstay.debug) {
            outcome.debug = mainstay.debug;
          }
          return _context.abrupt("return", outcome);
        case 48:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[10, 35, 38, 41], [18, 27]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
internals.entry = function (value, schema, prefs) {
  // Prepare state
  var _internals$tracer = internals.tracer(schema, prefs),
    tracer = _internals$tracer.tracer,
    cleanup = _internals$tracer.cleanup;
  var debug = prefs.debug ? [] : null;
  var links = schema._ids._schemaChain ? new Map() : null;
  var mainstay = {
    externals: [],
    warnings: [],
    tracer: tracer,
    debug: debug,
    links: links
  };
  var schemas = schema._ids._schemaChain ? [{
    schema: schema
  }] : null;
  var state = new State([], [], {
    mainstay: mainstay,
    schemas: schemas
  });

  // Validate value

  var result = exports.validate(value, schema, state, prefs);

  // Process value and errors

  if (cleanup) {
    schema.$_root.untrace();
  }
  var error = Errors.process(result.errors, value, prefs);
  return {
    value: result.value,
    error: error,
    mainstay: mainstay
  };
};
internals.tracer = function (schema, prefs) {
  if (schema.$_root._tracer) {
    return {
      tracer: schema.$_root._tracer._register(schema)
    };
  }
  if (prefs.debug) {
    Assert(schema.$_root.trace, 'Debug mode not supported');
    return {
      tracer: schema.$_root.trace()._register(schema),
      cleanup: true
    };
  }
  return {
    tracer: internals.ignore
  };
};
exports.validate = function (value, schema, state, prefs) {
  var overrides = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  if (schema.$_terms.whens) {
    schema = schema._generate(value, state, prefs).schema;
  }

  // Setup state and settings

  if (schema._preferences) {
    prefs = internals.prefs(schema, prefs);
  }

  // Cache

  if (schema._cache && prefs.cache) {
    var result = schema._cache.get(value);
    state.mainstay.tracer.debug(state, 'validate', 'cached', !!result);
    if (result) {
      return result;
    }
  }

  // Helpers

  var createError = function createError(code, local, localState) {
    return schema.$_createError(code, value, local, localState || state, prefs);
  };
  var helpers = {
    original: value,
    prefs: prefs,
    schema: schema,
    state: state,
    error: createError,
    warn: function warn(code, local, localState) {
      return state.mainstay.warnings.push(createError(code, local, localState));
    },
    message: function message(messages, local) {
      return schema.$_createError('custom', value, local, state, prefs, {
        messages: messages
      });
    }
  };

  // Prepare

  state.mainstay.tracer.entry(schema, state);
  var def = schema._definition;
  if (def.prepare && value !== undefined && prefs.convert) {
    var prepared = def.prepare(value, helpers);
    if (prepared) {
      state.mainstay.tracer.value(state, 'prepare', value, prepared.value);
      if (prepared.errors) {
        return internals.finalize(prepared.value, [].concat(prepared.errors), helpers); // Prepare error always aborts early
      }
      value = prepared.value;
    }
  }

  // Type coercion

  if (def.coerce && value !== undefined && prefs.convert && (!def.coerce.from || def.coerce.from.includes(typeof value))) {
    var coerced = def.coerce.method(value, helpers);
    if (coerced) {
      state.mainstay.tracer.value(state, 'coerced', value, coerced.value);
      if (coerced.errors) {
        return internals.finalize(coerced.value, [].concat(coerced.errors), helpers); // Coerce error always aborts early
      }
      value = coerced.value;
    }
  }

  // Empty value

  var empty = schema._flags.empty;
  if (empty && empty.$_match(internals.trim(value, schema), state.nest(empty), Common.defaults)) {
    state.mainstay.tracer.value(state, 'empty', value, undefined);
    value = undefined;
  }

  // Presence requirements (required, optional, forbidden)

  var presence = overrides.presence || schema._flags.presence || (schema._flags._endedSwitch ? 'ignore' : prefs.presence);
  if (value === undefined) {
    if (presence === 'forbidden') {
      return internals.finalize(value, null, helpers);
    }
    if (presence === 'required') {
      return internals.finalize(value, [schema.$_createError('any.required', value, null, state, prefs)], helpers);
    }
    if (presence === 'optional') {
      if (schema._flags.default !== Common.symbols.deepDefault) {
        return internals.finalize(value, null, helpers);
      }
      state.mainstay.tracer.value(state, 'default', value, {});
      value = {};
    }
  } else if (presence === 'forbidden') {
    return internals.finalize(value, [schema.$_createError('any.unknown', value, null, state, prefs)], helpers);
  }

  // Allowed values

  var errors = [];
  if (schema._valids) {
    var match = schema._valids.get(value, state, prefs, schema._flags.insensitive);
    if (match) {
      if (prefs.convert) {
        state.mainstay.tracer.value(state, 'valids', value, match.value);
        value = match.value;
      }
      state.mainstay.tracer.filter(schema, state, 'valid', match);
      return internals.finalize(value, null, helpers);
    }
    if (schema._flags.only) {
      var report = schema.$_createError('any.only', value, {
        valids: schema._valids.values({
          display: true
        })
      }, state, prefs);
      if (prefs.abortEarly) {
        return internals.finalize(value, [report], helpers);
      }
      errors.push(report);
    }
  }

  // Denied values

  if (schema._invalids) {
    var _match = schema._invalids.get(value, state, prefs, schema._flags.insensitive);
    if (_match) {
      state.mainstay.tracer.filter(schema, state, 'invalid', _match);
      var _report = schema.$_createError('any.invalid', value, {
        invalids: schema._invalids.values({
          display: true
        })
      }, state, prefs);
      if (prefs.abortEarly) {
        return internals.finalize(value, [_report], helpers);
      }
      errors.push(_report);
    }
  }

  // Base type

  if (def.validate) {
    var base = def.validate(value, helpers);
    if (base) {
      state.mainstay.tracer.value(state, 'base', value, base.value);
      value = base.value;
      if (base.errors) {
        if (!Array.isArray(base.errors)) {
          errors.push(base.errors);
          return internals.finalize(value, errors, helpers); // Base error always aborts early
        }
        if (base.errors.length) {
          errors.push.apply(errors, _toConsumableArray(base.errors));
          return internals.finalize(value, errors, helpers); // Base error always aborts early
        }
      }
    }
  }

  // Validate tests

  if (!schema._rules.length) {
    return internals.finalize(value, errors, helpers);
  }
  return internals.rules(value, errors, helpers);
};
internals.rules = function (value, errors, helpers) {
  var schema = helpers.schema,
    state = helpers.state,
    prefs = helpers.prefs;
  var _iterator2 = _createForOfIteratorHelper(schema._rules),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var rule = _step2.value;
      var definition = schema._definition.rules[rule.method];

      // Skip rules that are also applied in coerce step

      if (definition.convert && prefs.convert) {
        state.mainstay.tracer.log(schema, state, 'rule', rule.name, 'full');
        continue;
      }

      // Resolve references

      var ret = void 0;
      var args = rule.args;
      if (rule._resolve.length) {
        args = Object.assign({}, args); // Shallow copy
        var _iterator3 = _createForOfIteratorHelper(rule._resolve),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var key = _step3.value;
            var resolver = definition.argsByName.get(key);
            var resolved = args[key].resolve(value, state, prefs);
            var normalized = resolver.normalize ? resolver.normalize(resolved) : resolved;
            var invalid = Common.validateArg(normalized, null, resolver);
            if (invalid) {
              ret = schema.$_createError('any.ref', resolved, {
                arg: key,
                ref: args[key],
                reason: invalid
              }, state, prefs);
              break;
            }
            args[key] = normalized;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      // Test rule

      ret = ret || definition.validate(value, helpers, args, rule); // Use ret if already set to reference error

      var result = internals.rule(ret, rule);
      if (result.errors) {
        state.mainstay.tracer.log(schema, state, 'rule', rule.name, 'error');
        if (rule.warn) {
          var _state$mainstay$warni;
          (_state$mainstay$warni = state.mainstay.warnings).push.apply(_state$mainstay$warni, _toConsumableArray(result.errors));
          continue;
        }
        if (prefs.abortEarly) {
          return internals.finalize(value, result.errors, helpers);
        }
        errors.push.apply(errors, _toConsumableArray(result.errors));
      } else {
        state.mainstay.tracer.log(schema, state, 'rule', rule.name, 'pass');
        state.mainstay.tracer.value(state, 'rule', value, result.value, rule.name);
        value = result.value;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return internals.finalize(value, errors, helpers);
};
internals.rule = function (ret, rule) {
  if (ret instanceof Errors.Report) {
    internals.error(ret, rule);
    return {
      errors: [ret],
      value: null
    };
  }
  if (Array.isArray(ret) && (ret[0] instanceof Errors.Report || ret[0] instanceof Error)) {
    ret.forEach(function (report) {
      return internals.error(report, rule);
    });
    return {
      errors: ret,
      value: null
    };
  }
  return {
    errors: null,
    value: ret
  };
};
internals.error = function (report, rule) {
  if (rule.message) {
    report._setTemplate(rule.message);
  }
  return report;
};
internals.finalize = function (value, errors, helpers) {
  errors = errors || [];
  var schema = helpers.schema,
    state = helpers.state,
    prefs = helpers.prefs; // Failover value
  if (errors.length) {
    var failover = internals.default('failover', undefined, errors, helpers);
    if (failover !== undefined) {
      state.mainstay.tracer.value(state, 'failover', value, failover);
      value = failover;
      errors = [];
    }
  }

  // Error override

  if (errors.length && schema._flags.error) {
    if (typeof schema._flags.error === 'function') {
      errors = schema._flags.error(errors);
      if (!Array.isArray(errors)) {
        errors = [errors];
      }
      var _iterator4 = _createForOfIteratorHelper(errors),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var error = _step4.value;
          Assert(error instanceof Error || error instanceof Errors.Report, 'error() must return an Error object');
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    } else {
      errors = [schema._flags.error];
    }
  }

  // Default

  if (value === undefined) {
    var defaulted = internals.default('default', value, errors, helpers);
    state.mainstay.tracer.value(state, 'default', value, defaulted);
    value = defaulted;
  }

  // Cast

  if (schema._flags.cast && value !== undefined) {
    var caster = schema._definition.cast[schema._flags.cast];
    if (caster.from(value)) {
      var casted = caster.to(value, helpers);
      state.mainstay.tracer.value(state, 'cast', value, casted, schema._flags.cast);
      value = casted;
    }
  }

  // Externals

  if (schema.$_terms.externals && prefs.externals && prefs._externals !== false) {
    // Disabled for matching
    var _iterator5 = _createForOfIteratorHelper(schema.$_terms.externals),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var method = _step5.value.method;
        state.mainstay.externals.push({
          method: method,
          path: state.path,
          label: Errors.label(schema._flags, state, prefs)
        });
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  // Result

  var result = {
    value: value,
    errors: errors.length ? errors : null
  };
  if (schema._flags.result) {
    result.value = schema._flags.result === 'strip' ? undefined : /* raw */helpers.original;
    state.mainstay.tracer.value(state, schema._flags.result, value, result.value);
    state.shadow(value, schema._flags.result);
  }

  // Cache

  if (schema._cache && prefs.cache !== false && !schema._refs.length) {
    schema._cache.set(helpers.original, result);
  }
  return result;
};
internals.prefs = function (schema, prefs) {
  var isDefaultOptions = prefs === Common.defaults;
  if (isDefaultOptions && schema._preferences[Common.symbols.prefs]) {
    return schema._preferences[Common.symbols.prefs];
  }
  prefs = Common.preferences(prefs, schema._preferences);
  if (isDefaultOptions) {
    schema._preferences[Common.symbols.prefs] = prefs;
  }
  return prefs;
};
internals.default = function (flag, value, errors, helpers) {
  var schema = helpers.schema,
    state = helpers.state,
    prefs = helpers.prefs;
  var source = schema._flags[flag];
  if (prefs.noDefaults || source === undefined) {
    return value;
  }
  state.mainstay.tracer.log(schema, state, 'rule', flag, 'full');
  if (!source) {
    return source;
  }
  if (typeof source === 'function') {
    var args = source.length ? [Clone(state.ancestors[0]), helpers] : [];
    try {
      return source.apply(void 0, args);
    } catch (err) {
      errors.push(schema.$_createError("any.".concat(flag), null, {
        error: err
      }, state, prefs));
      return;
    }
  }
  if (typeof source !== 'object') {
    return source;
  }
  if (source[Common.symbols.literal]) {
    return source.literal;
  }
  if (Common.isResolvable(source)) {
    return source.resolve(value, state, prefs);
  }
  return Clone(source);
};
internals.trim = function (value, schema) {
  if (typeof value !== 'string') {
    return value;
  }
  var trim = schema.$_getRule('trim');
  if (!trim || !trim.args.enabled) {
    return value;
  }
  return value.trim();
};
internals.ignore = {
  active: false,
  debug: Ignore,
  entry: Ignore,
  filter: Ignore,
  log: Ignore,
  resolve: Ignore,
  value: Ignore
};